import angular from 'angular';

import AdOptionsDirective from './ad_options.directive';
import AdTypeController from './ad_type.controller';
import AdTypeMenuDirective from '../ad_types/ad_type_menu.directive';
import CreativeDemoFactory from './demo.factory';
import CreativeFromParamFactory from './creative_from_params.factory';
import creativePreview from './creative_preview_directive';
import creativePreviewRoutes from './router';
import CreativeService from '../creatives/service';
import DataService from './data_service';
import DcoAssetsService from './dco_assets.service';
import DspAppNexusController from './dsp.appnexus.controller';
import DspController from './dsp.controller';
import DspService from './dsp.service';
import DynamicNativeController from './dynamic_native.controller';
import EmbedController from './embed.controller';
import ExampleController from './example.controller';
import ExamplesService from './examples.service';
import ExportCreativesDirective from './export_creatives.directive';
import ExportVastDirective from './export_vast.directive';
import HomeController from './home.controller';
import IsImageFactory from './is_image.factory';
import LayoutController from './layout.controller';
import PartnerService from './partner.service';
import RenderService from './render.service';
import SavedController from './saved.controller';
import ShareableLinkService from './shareable_link.service';
import SitesService from './sites.service';
import strDeviceMotionRelay from './devicemotion_relay.directive';
import strEditableDemo from './editable_demo.directive';
import strEmbedLink from './embed_link.directive';
import strExampleEditItem from './example_edit_item.directive';
import PublisherSelect from './publisher_select.directive';
import strShareableLink from './shareable_link.directive';
import strVideoStatus from './video_status.directive';

// since these live in a different dir they should probably be moved or loaded
// in a different module, right?
import AdTypesFactory from '../partners/ad_types.factory';
import CustomSitesController from '../partners/custom_sites.controller';
import ExamplesEditController from '../examples/edit.controller';
import PartnerEditController from '../partners/edit.controller';
import PartnerIndexController from '../partners/index.controller';
import PartnerNewController from '../partners/new.controller';
import PartnerUtilitiesService from '../partners/utilities.service';
import PreviewGroupNewController from '../preview_groups/new.controller';
import PreviewGroupEditController from '../preview_groups/edit.controller';
import previewGroupRoutes from '../preview_groups/routes';
import PreviewGroupService from '../preview_groups/service';
import PreviewGroupShowController from '../preview_groups/show.controller';
import strCustomSites from '../partners/custom_sites.directive';
import translationsConfig from '../translations';

angular.module('generator.creativePreview', [
  'color.picker',
  'generator.analytics',
  'generator.creatives',
  'generator.shared',
  'generator.sites',
  'generator.dsp',
  'generator.dsp.adMarkup'
]);

angular
  .module('generator.creativePreview')
  .config(creativePreviewRoutes)
  .config(previewGroupRoutes)
  .config(translationsConfig);

angular
  .module('generator.creativePreview')
  .controller('AdTypeController', AdTypeController)
  .controller('CustomSitesController', CustomSitesController)
  .controller('DspAppNexusController', DspAppNexusController)
  .controller('DspController', DspController)
  .controller('DynamicNativeController', DynamicNativeController)
  .controller('EmbedController', EmbedController)
  .controller('ExampleController', ExampleController)
  .controller('ExamplesEditController', ExamplesEditController)
  .controller('HomeController', HomeController)
  .controller('LayoutController', LayoutController)
  .controller('PartnerEditController', PartnerEditController)
  .controller('PartnerIndexController', PartnerIndexController)
  .controller('PartnerNewController', PartnerNewController)
  .controller('PreviewGroupNewController', PreviewGroupNewController)
  .controller('PreviewGroupEditController', PreviewGroupEditController)
  .controller('PreviewGroupShowController', PreviewGroupShowController)
  .controller('SavedController', SavedController)
  .directive('adOptions', AdOptionsDirective)
  .directive('adTypeMenu', AdTypeMenuDirective)
  .directive('creativePreview', creativePreview)
  .directive('exportCreatives', ExportCreativesDirective)
  .directive('exportVast', ExportVastDirective)
  .directive('strCustomSites', strCustomSites)
  .directive('strDeviceMotionRelay', strDeviceMotionRelay)
  .directive('strEditableDemo', strEditableDemo)
  .directive('strEmbedLink', strEmbedLink)
  .directive('strExampleEditItem', strExampleEditItem)
  .directive('strPublisherSelect', PublisherSelect)
  .directive('strShareableLink', strShareableLink)
  .directive('strVideoStatus', strVideoStatus)
  .factory('AdTypesFactory', AdTypesFactory)
  .factory('CreativeDemoFactory', CreativeDemoFactory)
  .factory('CreativeFromParamFactory', CreativeFromParamFactory)
  .factory('DcoAssetsService', DcoAssetsService)
  .factory('IsImageFactory', IsImageFactory)
  .factory('ShareableLinkService', ShareableLinkService)
  .factory('SitesService', SitesService)
  .service('CreativeService', CreativeService)
  .service('DataService', DataService)
  .service('DspService', DspService)
  .service('ExamplesService', ExamplesService)
  .service('PartnerService', PartnerService)
  .service('PartnerUtilitiesService', PartnerUtilitiesService)
  .service('PreviewGroupService', PreviewGroupService)
  .service('RenderService', RenderService);
